// النصوص بقت في فولدر src/Locales (ملف لكل لغة: en, ar, ru, de, fr, es).
// الكائن ده بيتملى تلقائيًا باللغة اللي اتحمّلت (من Languagecontext)، وموجود عشان أي كود قديم بيستورده.
export const translations = {};
